import { DateUtils, TypeUtils } from '@vectord/utils';
import isEmpty from 'lodash/isEmpty';

import createErrorHandler from 'utils/createErrorHandler';

function validateRevisedSchedule(state) {
  const [errors, addError] = createErrorHandler();

  const classes = Object.values(state.sbatGroups);
  const dateSelectedForAll = classes.every(
    (cls) => !TypeUtils.isNullOrUndefined(cls.newDateOfTopic)
  );
  const { rescheduleReason } = state || {};

  const futureDateSelectedForAll = classes.every(
    (cls) => !cls.newDateOfTopic || new Date(cls.newDateOfTopic) > new Date()
  );

  // Get all class dates on minute level
  const allClassDates = classes.map((cls) =>
    Math.floor(new Date(cls.newDateOfTopic).getTime() / DateUtils.ONE_MINUTE)
  );
  const sameDateSelectedForMultiple =
    allClassDates.length !== new Set(allClassDates).size;

  if (!dateSelectedForAll) {
    addError('revised_schedule', 'Select date for all classes!');
  }

  if (!futureDateSelectedForAll) {
    addError('revised_schedule', 'Past dates selected for few classes!');
  }

  if (sameDateSelectedForMultiple) {
    addError('revised_schedule', 'Same date selected for multiple classes!');
  }

  if (
    rescheduleReason?.value === 8 &&
    (!rescheduleReason?.customReason ||
      isEmpty(rescheduleReason?.customReason.trim()))
  ) {
    addError('reason', 'Please enter a reason for rescheduling.');
  }

  return errors;
}

export default validateRevisedSchedule;
